// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/ttf/JetBrainsMono-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/webfonts/JetBrainsMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/ttf/pobeda-regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "JetBrainsMono-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}

@font-face {
  font-family: "Pobeda-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

body {
  margin: 0;
  font-family: 'JetBrainsMono-Regular', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.jb {
  font-family: 'JetBrainsMono-Regular', sans-serif;
}

.black {
  background-color: black;
  color: white;
  min-height: 100vh;
  padding: 0 0 10px 0;
}

#main {
  min-height: 100vh;
}

#menu {
  padding: 6vw 0 0 0;
  margin: 0 6vw;
}

#menu_title {
  font-family: 'Pobeda-Regular', 'JetBrainsMono-Regular', sans-serif;
  font-size: 10vw;
  text-align: center;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-weight: bold;
}

#menu_list {
  margin: 2vw 0 0 0;
}

#ads {
  height: 100vh;
}

#drink {
  cursor: pointer;
  height: 10vw;
  margin: 0 0 2vw 0;
  display: flex;
  justify-content: space-between;
  width: calc(100% + 2.5vw);
}

#drink_img {
  width: 10vw;
  height: 10vw;
  display: inline-block;
}

#drink_img img{
  width: 10vw;
  height: 10vw;
}

#drink_title {
  font-size: 5.12vw;
  text-align: left;
  line-height: 0.5;
  padding: 0 0 0 2vw;
  margin: auto 0;
  width: calc(100% - 20vw);
}

#drink_price {
  width: 10vw;
  height: 10vw;
  font-size: 5.12vw;
  text-align: center;
  line-height: 10vw;
  display: block;
  vertical-align: middle;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

#menu_title_glass {
  margin: 0 10px;
  justify-content: space-around;
  font-size: 5vw;
}

#menu_title_glass span {
  align-self: flex-end;
  font-size: 3vw;
}
#menu_title_glass_img {
  height: 8vw;
  width: auto;
}

#drink_new {
  width: auto;
  height: 10vw;
  position: relative;
  display: inline-block;
  margin: 0 10px;
  /* background: url("./images/new.png");
  background-repeat: no-repeat, no-repeat;
  background-color: transparent;
  background-size: contain; */
}

#drink_hit {
  width: auto;
  height: 10vw;
  position: relative;
  display: inline-block;
  margin: 0 10px;
  /* background: url("./images/new.png");
  background-repeat: no-repeat, no-repeat;
  background-color: transparent;
  background-size: contain; */
}

#drink_details {
  background-color: transparent;
  display: inline-block;
  width: 100vw;
  height: 100vh;

  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center center;
  background-attachment: fixed;
}

#drink_details #drink_details_close {
  position: absolute;
  top: 2em;
  right: 2em;
  opacity: 60%;
}

#drink_details #drink_details_prev {
  position: absolute;
  top: calc(50% - 2em);
  left: 2em;
  opacity: 60%;
}

#drink_details #drink_details_next {
  position: absolute;
  top: calc(50% - 2em);
  right: 2em;
  opacity: 60%;
}

#drink_details #drink_details_name {
  background-color: rgba(0, 0, 0, .5);
  font-size: 5vw;
  color: #ffffff;
  border-radius: 25px;
  position: absolute;
  top: 5%;
  width: max-content;
  height: -moz-fit-content;
  height: fit-content;
  line-height: normal;
  padding: 20px;
  text-transform: uppercase;
  left: 50%;
  transform: translate(-50%, 0);
}

#drink_details #drink_details_info {
  background-color: rgba(0, 0, 0, .5);
  font-size: 3vw;
  color: #ffffff;
  border-radius: 25px;
  position: absolute;
  bottom: 5%;
  padding: 20px;
  margin: 0 0vw;
  font-weight: 600;
  text-align: center;
  line-height: normal;
  min-height: 10vw;
  margin: 0 5vw;
}

#menu_bottom {
  position: fixed;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%, 0);
}

.container {
  width: 100%;
  height: 100%;
  background-color: #c9d6df;
  display: flex;
  align-items: center;
  justify-content: center;
}

.field {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 300px;
}


@keyframes wheel {
  to {
    opacity: 0;
    top: 60px;
  }
}

.scroll {
  width: 60px;
  height: 60px;
  border: 3px solid #FFF;
  border-radius: 50%;
  position: relative;
  animation: down 1.5s infinite;
  -webkit-animation: down 1.5s infinite;

  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 20px rgba(255, 255, 255, .25);

  &::before {
    content: '';
    position: absolute;
    top: 15px;
    left: 18px;
    width: 18px;
    height: 18px;
    border-left: 3px solid #FFF;
    border-bottom: 3px solid #FFF;
    transform: rotate(-45deg);
  }
}

@keyframes down {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translateY(15px);
  }
  40% {
    transform: translate(0);
  }
}

@keyframes scroll {
  0% {
    height: 40px;
  }
  30% {
    height: 70px;
  }
  60% {
    height: 40px;
  }
}

.hidden {
  display: none;

  * {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,wHAAyI;AAC3I;;AAEA;EACE,6BAA6B;EAC7B,+DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd;;;6BAG2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd;;;6BAG2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,aAAa;;EAEb,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;;;AAGA;EACE;IACE,UAAU;IACV,SAAS;EACX;AACF;;AASA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;;EAErC,2CAA2C;EAC3C,6CAA6C;;EAE7C;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;AACF;;AAcA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;;EAEb;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@font-face {\n  font-family: \"JetBrainsMono-Regular\";\n  src: url(\"./fonts/ttf/JetBrainsMono-Regular.ttf\") format('truetype'), url(\"./fonts/webfonts/JetBrainsMono-Regular.woff2\") format('woff2');\n}\n\n@font-face {\n  font-family: \"Pobeda-Regular\";\n  src: url(\"./fonts/ttf/pobeda-regular.ttf\") format('truetype');\n}\n\nbody {\n  margin: 0;\n  font-family: 'JetBrainsMono-Regular', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.jb {\n  font-family: 'JetBrainsMono-Regular', sans-serif;\n}\n\n.black {\n  background-color: black;\n  color: white;\n  min-height: 100vh;\n  padding: 0 0 10px 0;\n}\n\n#main {\n  min-height: 100vh;\n}\n\n#menu {\n  padding: 6vw 0 0 0;\n  margin: 0 6vw;\n}\n\n#menu_title {\n  font-family: 'Pobeda-Regular', 'JetBrainsMono-Regular', sans-serif;\n  font-size: 10vw;\n  text-align: center;\n  line-height: normal;\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  font-weight: bold;\n}\n\n#menu_list {\n  margin: 2vw 0 0 0;\n}\n\n#ads {\n  height: 100vh;\n}\n\n#drink {\n  cursor: pointer;\n  height: 10vw;\n  margin: 0 0 2vw 0;\n  display: flex;\n  justify-content: space-between;\n  width: calc(100% + 2.5vw);\n}\n\n#drink_img {\n  width: 10vw;\n  height: 10vw;\n  display: inline-block;\n}\n\n#drink_img img{\n  width: 10vw;\n  height: 10vw;\n}\n\n#drink_title {\n  font-size: 5.12vw;\n  text-align: left;\n  line-height: 0.5;\n  padding: 0 0 0 2vw;\n  margin: auto 0;\n  width: calc(100% - 20vw);\n}\n\n#drink_price {\n  width: 10vw;\n  height: 10vw;\n  font-size: 5.12vw;\n  text-align: center;\n  line-height: 10vw;\n  display: block;\n  vertical-align: middle;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n#menu_title_glass {\n  margin: 0 10px;\n  justify-content: space-around;\n  font-size: 5vw;\n}\n\n#menu_title_glass span {\n  align-self: flex-end;\n  font-size: 3vw;\n}\n#menu_title_glass_img {\n  height: 8vw;\n  width: auto;\n}\n\n#drink_new {\n  width: auto;\n  height: 10vw;\n  position: relative;\n  display: inline-block;\n  margin: 0 10px;\n  /* background: url(\"./images/new.png\");\n  background-repeat: no-repeat, no-repeat;\n  background-color: transparent;\n  background-size: contain; */\n}\n\n#drink_hit {\n  width: auto;\n  height: 10vw;\n  position: relative;\n  display: inline-block;\n  margin: 0 10px;\n  /* background: url(\"./images/new.png\");\n  background-repeat: no-repeat, no-repeat;\n  background-color: transparent;\n  background-size: contain; */\n}\n\n#drink_details {\n  background-color: transparent;\n  display: inline-block;\n  width: 100vw;\n  height: 100vh;\n\n  background-repeat: no-repeat;\n  background-size: auto 100%;\n  background-position: center center;\n  background-attachment: fixed;\n}\n\n#drink_details #drink_details_close {\n  position: absolute;\n  top: 2em;\n  right: 2em;\n  opacity: 60%;\n}\n\n#drink_details #drink_details_prev {\n  position: absolute;\n  top: calc(50% - 2em);\n  left: 2em;\n  opacity: 60%;\n}\n\n#drink_details #drink_details_next {\n  position: absolute;\n  top: calc(50% - 2em);\n  right: 2em;\n  opacity: 60%;\n}\n\n#drink_details #drink_details_name {\n  background-color: rgba(0, 0, 0, .5);\n  font-size: 5vw;\n  color: #ffffff;\n  border-radius: 25px;\n  position: absolute;\n  top: 5%;\n  width: max-content;\n  height: fit-content;\n  line-height: normal;\n  padding: 20px;\n  text-transform: uppercase;\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n\n#drink_details #drink_details_info {\n  background-color: rgba(0, 0, 0, .5);\n  font-size: 3vw;\n  color: #ffffff;\n  border-radius: 25px;\n  position: absolute;\n  bottom: 5%;\n  padding: 20px;\n  margin: 0 0vw;\n  font-weight: 600;\n  text-align: center;\n  line-height: normal;\n  min-height: 10vw;\n  margin: 0 5vw;\n}\n\n#menu_bottom {\n  position: fixed;\n  bottom: 5%;\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n\n.container {\n  width: 100%;\n  height: 100%;\n  background-color: #c9d6df;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.field {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  width: 300px;\n}\n\n\n@keyframes wheel {\n  to {\n    opacity: 0;\n    top: 60px;\n  }\n}\n\n@-webkit-keyframes wheel {\n  to {\n    opacity: 0;\n    top: 60px;\n  }\n}\n\n.scroll {\n  width: 60px;\n  height: 60px;\n  border: 3px solid #FFF;\n  border-radius: 50%;\n  position: relative;\n  animation: down 1.5s infinite;\n  -webkit-animation: down 1.5s infinite;\n\n  background-color: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 0 20px rgba(255, 255, 255, .25);\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 15px;\n    left: 18px;\n    width: 18px;\n    height: 18px;\n    border-left: 3px solid #FFF;\n    border-bottom: 3px solid #FFF;\n    transform: rotate(-45deg);\n  }\n}\n\n@keyframes down {\n  0% {\n    transform: translate(0);\n  }\n  20% {\n    transform: translateY(15px);\n  }\n  40% {\n    transform: translate(0);\n  }\n}\n\n@-webkit-keyframes down {\n  0% {\n    transform: translate(0);\n  }\n  20% {\n    transform: translateY(15px);\n  }\n  40% {\n    transform: translate(0);\n  }\n}\n\n@keyframes scroll {\n  0% {\n    height: 40px;\n  }\n  30% {\n    height: 70px;\n  }\n  60% {\n    height: 40px;\n  }\n}\n\n.hidden {\n  display: none;\n\n  * {\n    display: none !important;\n  }\n}\n\n@-webkit-keyframes scroll {\n  0% {\n    height: 40px;\n  }\n  30% {\n    height: 70px;\n  }\n  60% {\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
